import {CustomerAddressType} from 'desktop/types/customerAddressesType';

import {AssociationType, AdditionalFieldsMapType} from './applyAssociationsTypes';

export const customerAddressAssociations: Array<AssociationType> = [
    {field: 'firstName', target: 'firstName'},
    {field: 'lastName', target: 'lastName'},
    {field: 'street', target: 'address'},
    {field: 'aptSuiteOther', target: 'other'},
    {field: 'city', target: 'city'},
    {field: 'regionId', target: 'regionID'},
    {field: 'regionCode', target: 'state'},
    {field: 'region', isFallbackValue: true, target: 'state'},
    {field: 'zipCode', target: 'postal'},
    {field: 'country', target: 'country'},
    {field: 'email', target: 'email'},
    {field: 'phone', target: 'phone'},
    {field: 'addressId', target: 'addressID'},
];

export type AssociationsResultType = {
    [key: string]: AdditionalFieldsMapType & {error?: boolean; value?: string; success?: boolean};
};

/**
 * Perform address mapping using associations structure and returns modified address
 * @param {Array<AssociationType>} associations - Associations map
 * @param {CustomerAddressType} address - Address for mapping
 * @param {AdditionalFieldsMapType} additionalFieldsMap - Additional fields for mapping used as fallback to existing values
 * @returns {AddressType} - Mapped address
 */
export const applyAssociations = (
    associations: Array<AssociationType>,
    address: CustomerAddressType,
    additionalFieldsMap: AdditionalFieldsMapType = {},
): AssociationsResultType => {
    const result: AssociationsResultType = {};
    const validationFields = {error: false, success: false};

    associations.forEach(({field, isAdditionalValue, isFallbackValue, target}) => {
        const additionalFields = additionalFieldsMap[field]
            ? additionalFieldsMap[field]?.({
                  field,
                  target,
                  value: address[field],
              })
            : {};
        if (isAdditionalValue) {
            const {value: previouslyAttachedValue} = result[target];
            result[target] = {
                value: address[field]
                    ? [previouslyAttachedValue, address[field]].join(', ')
                    : previouslyAttachedValue,
                ...validationFields,
                ...additionalFields,
            };
        } else if (isFallbackValue) {
            if (result[target].value === '') {
                result[target] = {
                    value: address[field],
                    ...validationFields,
                    ...additionalFields,
                };
            }
        } else {
            result[target] = {
                value: address[field],
                ...validationFields,
                ...additionalFields,
            };
        }
    });

    return result;
};
